const contact = {
    surname: '',
    name: '',
    birth_date: '',
    cap: '',
    email: '',
    phone: '',
    enable_marketing: false,
    birth_nation_id: '',
    birth_prov_id: '',
    birth_place_id: '',
    nation_id: '',
    prov_id: '',
    place_id: '',
};

export default contact
